/*
 * Gift code box for the cart page AND the cart drawer.
 *
 * How it works:
 *  1. Puts a "Have a gift code?" box above every checkout button it finds
 *     (cart page and cart drawer), and re-adds it whenever the drawer re-renders.
 *  2. When a customer submits a code and the cart is at least THRESHOLD (gift not counted),
 *     the gift is added to the cart and the code is stored for checkout.
 *  3. The gift line carries a hidden property (_free_gift) so this script only ever
 *     touches the gift it added, never one the customer bought normally.
 *  4. If the cart drops below THRESHOLD, the added gift is removed.
 *
 * The codes themselves are NOT in this file. Shopify validates them at checkout.
 */
(function () {
  if (window.__giftCodeLoaded) return;
  window.__giftCodeLoaded = true;

  var GIFT_VARIANT_ID = 48956160278779;
  var THRESHOLD = 999; // rupees, gift not counted
  var FLAG = 'giftCodeClaimed';

  var origFetch = window.fetch.bind(window);
  var running = false;
  var cleanTimer = null;
  var injectTimer = null;

  /* ---------- helpers ---------- */

  function post(url, body) {
    return origFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function getCart() {
    var res = await origFetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function analyse(cart) {
    var gift = null;
    var spend = 0; // paise, excluding our gift line
    cart.items.forEach(function (item) {
      var isOurGift =
        item.variant_id === GIFT_VARIANT_ID &&
        item.properties &&
        item.properties._free_gift === 'true';
      if (isOurGift) gift = item;
      else spend += item.original_line_price;
    });
    return { gift: gift, spend: spend };
  }

  /* ---------- the code box ---------- */

  function buildBox() {
    var box = document.createElement('div');
    box.className = 'gift-box';
    box.style.cssText = 'margin:12px 0;width:100%;text-align:left;';
    box.innerHTML =
      '<label style="display:block;font-weight:600;margin-bottom:6px;">Have a gift code?</label>' +
      '<div style="display:flex;gap:8px;">' +
      '<input class="gift-box__input" type="text" autocomplete="off" placeholder="Enter your code" ' +
      'style="flex:1;min-width:0;padding:10px;border:1px solid currentColor;border-radius:6px;' +
      'background:transparent;color:inherit;text-transform:uppercase;">' +
      '<button class="gift-box__btn" type="button" ' +
      'style="padding:10px 16px;border-radius:6px;cursor:pointer;">Apply</button>' +
      '</div>' +
      '<p class="gift-box__msg" style="margin:8px 0 0;font-size:0.9em;" aria-live="polite"></p>';
    return box;
  }

  function inject() {
    var targets = document.querySelectorAll('[name="checkout"], a[href="/checkout"]');
    targets.forEach(function (el) {
      if (el.closest('.gift-box') || !el.parentNode) return;
      if (el.parentNode.querySelector(':scope > .gift-box')) return;
      el.parentNode.insertBefore(buildBox(), el);
    });
  }

  function scheduleInject() {
    clearTimeout(injectTimer);
    injectTimer = setTimeout(inject, 150);
  }

  async function claim(box) {
    var input = box.querySelector('.gift-box__input');
    var btn = box.querySelector('.gift-box__btn');
    var msg = box.querySelector('.gift-box__msg');
    var code = input.value.replace(/\s+/g, '').toUpperCase();

    if (!/^[A-Z0-9]{6,20}$/.test(code)) {
      msg.textContent = 'Please enter a valid code.';
      return;
    }

    btn.disabled = true;
    try {
      var a = analyse(await getCart());
      var needed = THRESHOLD * 100;
      if (a.spend < needed) {
        msg.textContent = 'Add Rs. ' + Math.ceil((needed - a.spend) / 100) + ' more to unlock your gift.';
        btn.disabled = false;
        return;
      }
      if (!a.gift) {
        await post('/cart/add.js', {
          items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } }]
        });
      }
      sessionStorage.setItem(FLAG, '1');
      msg.textContent = 'Gift added. Your code will be applied at checkout.';
      // Stores the code for checkout, then returns to the page the customer was on.
      var back = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
    } catch (err) {
      console.error(err);
      msg.textContent = 'Something went wrong. Please try again.';
      btn.disabled = false;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.gift-box__btn');
    if (!btn) return;
    e.preventDefault();
    claim(btn.closest('.gift-box'));
  });

  // Enter inside the box must not submit the cart form (that would go to checkout).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('.gift-box__input');
    if (!input) return;
    e.preventDefault();
    e.stopPropagation();
    claim(input.closest('.gift-box'));
  }, true);

  /* ---------- keep the cart consistent ---------- */

  async function cleanup() {
    if (running) return;
    running = true;
    try {
      var a = analyse(await getCart());
      if (a.gift && (!sessionStorage.getItem(FLAG) || a.spend < THRESHOLD * 100)) {
        await post('/cart/change.js', { id: a.gift.key, quantity: 0 });
        window.location.reload();
      } else if (a.gift && a.gift.quantity > 1) {
        await post('/cart/change.js', { id: a.gift.key, quantity: 1 });
        window.location.reload();
      }
    } catch (err) {
      console.error(err);
    }
    running = false;
  }

  function scheduleCleanup() {
    clearTimeout(cleanTimer);
    cleanTimer = setTimeout(cleanup, 500);
  }

  // Re-check after any cart change made through fetch.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (!running && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(url)) {
      p.then(scheduleCleanup).catch(function () {});
    }
    return p;
  };

  /* ---------- start ---------- */

  function start() {
    inject();
    scheduleCleanup();
    new MutationObserver(scheduleInject).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', scheduleCleanup);
})();
